var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{staticClass:"text-dark font-weight-bold",attrs:{"for":_vm.props.for}},[_vm._v("\n    "+_vm._s(_vm.props.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }